import SectionSdk from '@wix/thunderbolt-elements/src/components/Sections/Section/corvid/Section.corvid';


const Section = {
  sdk: SectionSdk
};


export const components = {
  ['Section']: Section
};

